import { render } from "./DatabaseConfigScreen.vue?vue&type=template&id=43c192a3&scoped=true"
import script from "./DatabaseConfigScreen.vue?vue&type=script&lang=js"
export * from "./DatabaseConfigScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=43c192a3&lang=scss&scoped=true&external"
import "./DatabaseConfigScreen.vue?vue&type=style&index=1&id=43c192a3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43c192a3"]])

export default __exports__